export default __webpack_public_path__ + "static/project-slide-7-768-700-e8a5f2c07e103167e5b73daf38cbdcad.webp";